export function Tracker() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_346_17035)">
        <path
          d="M7.57031 14.0145V11.9838C9.92416 11.5684 11.7242 9.49147 11.7242 6.99916C11.7242 4.18378 9.46262 1.92224 6.64724 1.92224C3.83185 1.92224 1.57031 4.18378 1.57031 6.99916C1.57031 9.49147 3.37031 11.5684 5.72416 11.9838V14.0145C3.37031 14.4299 1.57031 16.5069 1.57031 18.9992C1.57031 21.8145 3.83185 24.0761 6.64724 24.0761C9.46262 24.0761 11.7242 21.8145 11.7242 18.9992C11.7242 16.5069 9.92416 14.4761 7.57031 14.0145ZM3.41647 6.99916C3.41647 5.19916 4.84724 3.76839 6.64724 3.76839C8.44724 3.76839 9.878 5.19916 9.878 6.99916C9.878 8.79916 8.44724 10.2299 6.64724 10.2299C4.84724 10.2299 3.41647 8.84532 3.41647 6.99916Z"
          fill="currentColor"
        />
        <path
          d="M14.5403 5.15295H22.8018C23.3095 5.15295 23.7249 5.56834 23.7249 6.07603V7.92218C23.7249 8.42988 23.3095 8.84526 22.8018 8.84526H14.5403C14.0326 8.84526 13.6172 8.42988 13.6172 7.92218V6.07603C13.6172 5.56834 14.0326 5.15295 14.5403 5.15295Z"
          fill="currentColor"
        />
        <path
          d="M14.5403 17.153H22.8018C23.3095 17.153 23.7249 17.5683 23.7249 18.076V19.9222C23.7249 20.4299 23.3095 20.8453 22.8018 20.8453H14.5403C14.0326 20.8453 13.6172 20.4299 13.6172 19.9222V18.076C13.6172 17.6145 14.0326 17.153 14.5403 17.153Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_346_17035">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.554688 0.90686)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
